import { Flex, Text, Select } from '@scale/scaleui-radix';
import type { HubstaffTimeTracking } from '@scale/genai-compass-shared/cards/hubstaff_member_actions';

interface TimeTrackingSelectorProps {
  timeTracking: HubstaffTimeTracking | undefined;
  onChange: (timeTracking: HubstaffTimeTracking) => void;
}

export default function TimeTrackingSelector({
  timeTracking,
  onChange,
}: TimeTrackingSelectorProps) {
  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="bold">
        Step 5: Select time tracking setting <span style={{ color: 'red' }}>*</span>
      </Text>
      <Select.Root
        value={timeTracking}
        onValueChange={value => onChange(value as HubstaffTimeTracking)}
      >
        <Select.Trigger placeholder="Select time tracking setting" />
        <Select.Content>
          <Select.Item value="Enabled">Enabled</Select.Item>
          <Select.Item value="Disabled">Disabled</Select.Item>
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
